module.exports = __webpack_public_path__ + "static/assets/7fdc70da1f9e1a849ff65d27993a826b.svg";